import * as firebase from "firebase";
import { FacilitySettingsModel } from "@/models/FacilitySettings";
import { ResidentAccessesOnMyhub } from "@/enums/ResidentAccessesOnMyhub";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import ConfirmMessageDlg from "@/components/popup/confirm-message-dialog/ConfirmMessageDlg.vue";
import Loader from "@/components/loader/Loader.vue";
import { TvSkinEnum } from '@/enums/TvSkinEnum';
import { toTranslationKey } from "@/utils/stringFormat";
import AssignDeviceDialog from '../assign-device/AssignDeviceDialog.vue';
import { UserTypeEnum } from "@/enums/UserTypeEnum";

export default {
  name: "ResidentSettingsDlg",
  components: {
    ValidationObserver,
    ValidationProvider,
    ConfirmMessageDlg,
    AssignDeviceDialog,
    Loader
  },
  data() {
    return {
      settingsDialog: false,
      loading: false,
      tvSkins: [...Object.values(TvSkinEnum)],
      tvSkinEnum: TvSkinEnum,
      residentAccessesOnMyhub: ResidentAccessesOnMyhub,
      loadingContentCategories: false,
      assignDeviceDialogShow: false,
      residentContentCategories: [],
      allResidentDevices: [],
      loadingAllResidentDevices: false,
      updatedDevices: []
    }
  },
  methods: {
    async open(residentId) {
      this.loadingAllResidentDevices = true
      this.allResidentDevices = []
      this.updatedDevices = []
      this.settingsDialog = true;
      this.setContentCategories()
      //load settings that may have changed in the Facility Settings
      await this.$store.dispatch("getFacility")
      await this.$store.dispatch("getResident", residentId)
      await this.$store.dispatch("getDevicesByResidentId", this.resident.id);
      this.allResidentDevices = this.residentDevices
      this.loadingAllResidentDevices = false
    },

    openAssignDeviceDialog() {
      this.assignDeviceDialogShow = true
      if (this.$refs.assignDeviceDialogRef) this.$refs.assignDeviceDialogRef.open()
    },
    async setContentCategories() {
      this.loadingContentCategories = true
      this.residentContentCategories = (await firebase.firestore().collection("contentCategories")
        .where('facilityId', '==', this.facility.id)
        .get()).docs.map((x: any) => {
          const category: any = { id: x.id, ...x.data() }
          category.isEnabled = category.disabledForResidentsIds ? !category.disabledForResidentsIds.includes(this.resident.id) : true
          return category
        })

      this.loadingContentCategories = false
    },
    async save() {
      this.loading = true;
      await this.updateResidentInfo()
      await this.updateDevicesSkins()
      this.$emit('onResidentSettingsUpdated')
      this.loading = false;
      this.settingsDialog = false;
    },
    formatText(text) {
      if (!text || text.length < 26) {
        return text;
      }

      return text.substring(0, 26) + '...';
    },
    translateAccessesOnMyhub(name) {
      const camelCaseName = toTranslationKey(name)
      const translated = this.$i18n.t(`ResidentsSettings.AccessOnMyHub.${camelCaseName}`)
      return this.formatText(translated)
    },
    async updateResidentInfo() {
      delete this.resident.suggestedUserStories
      await this.$store.dispatch('updateResidentInfo', this.resident);
    },
    async updateResidentConentCategory(category) {
      console.log('categoryId: ' + category.id + ' residentId: ' + this.resident.id)

      const snap = await firebase.firestore().collection("contentCategories").doc(category.id).get()
      const snapData = snap.data()

      if (category.isEnabled === true) {
        const disabledForResidentsIds = (snapData.disabledForResidentsIds || []).filter(id => id != this.resident.id)
        snap.ref.update({ disabledForResidentsIds: disabledForResidentsIds })
      } else {
        const disabledForResidentsIds = snapData.disabledForResidentsIds || []
        disabledForResidentsIds.push(this.resident.id)
        snap.ref.update({ disabledForResidentsIds: disabledForResidentsIds })
      }
    },
    async updateDevicesSkins() {
      const updatedDevices = this.updatedDevices
      if(!updatedDevices.length) return

      for (const updates of updatedDevices) {
        const deviceRef = firebase.firestore().collection('devices').doc(updates.deviceId);
        const deviceSnap = await deviceRef.get();
        const deviceData = deviceSnap.data();
        
        if (deviceData.skinOverride !== updates.skinOverride) {
          await deviceRef.update({ skinOverride: updates.skinOverride });
          console.log('updated device: ' + updates.deviceId);
        }
      }
    },
    onSelectDeviceSkin(deviceId, skinOverride) {
      if (this.updatedDevices.some(x => x.deviceId == deviceId)) return

      if (skinOverride == TvSkinEnum.Default) {
        skinOverride = ''
      }

      this.updatedDevices.push({ deviceId: deviceId, skinOverride: skinOverride })
    },
    unAssignDevice(deviceId) {

      this.$refs.confirmationModal
        .open(null, this.$t('DeviceView.AreYouSureYouWantToUnassignTheDevice'), false, "", null,
          this.$t('DeviceView.DeviceHasBeenUnassigned'),
          this.$t('DeviceView.AnErrorOccurredDuringTheProcess'),
          this.$t('DeviceView.DeviceIsBeingUnassignedAndWillBeLoggedOutShortly')
        )
        .then(response => {
          if (response && response.agree) {

            this.$refs.confirmationModal.load();

            this.$store.dispatch("unAssignDevice", {
              userId: this.resident.id,              
              deviceId: deviceId,
              userType: UserTypeEnum.Resident
            }).then((result) => {
              if(result===true){
                this.$refs.confirmationModal.cancel();

                this.allResidentDevices = this.allResidentDevices.filter(x=>x.id !== deviceId) 
  
                if (!this.allResidentDevices.length) {
                  this.$router.push("/devices");
                }
              }
              else{
                this.$toast.open({
                  message: this.$t("GeneralTranslations.UnhandledError"),
                  type: "error"
              });
              }
            })
          }
        });
    },
    isEnableFeatures(item) {
      if (item.name === this.residentAccessesOnMyhub.PremiumServices && this.facility.additionalServicesEnabled) {
        return false;
      }
      if (item.name === this.residentAccessesOnMyhub.LifestyleEvents && this.facility.additionalServicesEnabled) {
        return false;
      }
      if (item.name === this.residentAccessesOnMyhub.Community && this.facility.featureLifestyle) {
        return false;
      }
      if (item.name === this.residentAccessesOnMyhub.Media && this.facility.mediaEnabled) {
        return false;
      }
      if (item.name === this.residentAccessesOnMyhub.Maintenance && this.facility.maintenanceEnabled) {
        return false;
      }
      if (item.name === this.residentAccessesOnMyhub.Noticeboard && this.facility.noticeboardEnabled) {
        return false;
      }
      if (item.name === this.residentAccessesOnMyhub.Budget) {
        return false;
      }
      if (item.name === this.residentAccessesOnMyhub.Calendar && this.facility.featureLifestyle) {
        return false;
      }
      if (item.name === this.residentAccessesOnMyhub.DisplayBirthday && this.facility.featureFamilyEngagement) {
        return false;
      }
      if (item.name === this.residentAccessesOnMyhub.VoiceAssistant) {
        return false;
      }
      if (item.name === this.residentAccessesOnMyhub.ResidentEventPictures && this.facility.isEnableResidentEventPictures) {
        return false;
      }
      if (item.name === this.residentAccessesOnMyhub.WeatherWidget) {
        return false;
      }
      if (item.name === this.residentAccessesOnMyhub.News) {
        return false;
      }
      if (item.name === this.residentAccessesOnMyhub.Event) {
        return false;
      }
      if (item.name === this.residentAccessesOnMyhub.TakePhoto && this.facility.residentCanTakePhoto) {
        return false;
      }
      if (item.name === this.residentAccessesOnMyhub.Family) {
        return false;
      }
      if (item.name === this.residentAccessesOnMyhub.DisplayResidentInCommunityDirectory) {
        return false;
      }
      return true;
    }
  },
  watch:{
    ['facility.featureFamilyEngagement'](value: boolean) {
      this.resident.isEnableStaffAppNotifications = value
    },
    ['facility.isStaffCanLogInOnBehalfOfResident'](value: boolean) {
      this.resident.isStaffCanLoginAsResident = value
    }
  },
  computed: {
    resident() {
      return this.$store.state.residentModule.currentResident;
    },
    residentDevices() {
      return this.$store.state.devicesModule.residentDevices
    },
    facility(): FacilitySettingsModel {
      return this.$store.state.facilityModule.selectedFacility;
    }
  }
}